import Rails from 'rails-ujs';

function refreshCSRFTokens() {
  Rails.refreshCSRFTokens();
}

document.addEventListener('turbolinks:load', refreshCSRFTokens);
document.addEventListener('ajax:success', refreshCSRFTokens);
